import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule, IConfig } from 'ngx-mask';

import { SedanComponent } from './sedan/sedan.component';
import { MicrobusComponent } from './microbus/microbus.component';
import { SuvComponent } from './suv/suv.component';
import { TruckDoubleCabinComponent } from './truck-double-cabin/truck-double-cabin.component';
import { TruckSingleCabinComponent } from './truck-single-cabin/truck-single-cabin.component';
import { CargoVanComponent } from './cargo-van/cargo-van.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonCompModule } from '../common/common-comp.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIonicImageViewerModule } from 'ngx-ionic-image-viewer';
import { ConnectivityTestComponent } from './connectivity-test/connectivity-test.component';
import { ActionButtonComponent } from './connectivity-test/action-button/action-button.component';
import { WholeToFixedPipe } from './pipes/whole-to-fixed.pipe';
import { RatingActivityComponent } from './rating-activity/rating-activity.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { VamNamvbarComponent } from './vam-namvbar/vam-namvbar.component';
import { RouterModule } from '@angular/router';
import { ReportAssistantComponent } from './report-assistant/report-assistant.component';

@NgModule({
  declarations: [
    SedanComponent,
    MicrobusComponent,
    SuvComponent,
    TruckDoubleCabinComponent,
    TruckSingleCabinComponent,
    CargoVanComponent,
    ConnectivityTestComponent,
    ActionButtonComponent,
    WholeToFixedPipe,
    RatingActivityComponent,
    NavbarComponent,
    FooterComponent,
    VamNamvbarComponent,
    ReportAssistantComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CommonCompModule,
    NgSelectModule,
    NgxIonicImageViewerModule,
    TranslateModule.forChild({
      extend: true
    }),
    NgxMaskModule.forRoot(),
    RouterModule
  ],
  exports: [
    SedanComponent,
    MicrobusComponent,
    SuvComponent,
    TruckDoubleCabinComponent,
    TruckSingleCabinComponent,
    CargoVanComponent,
    WholeToFixedPipe,
    RatingActivityComponent,
    NavbarComponent,
    FooterComponent,
    VamNamvbarComponent,
    ReportAssistantComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
